<template>
    <div class="p-3">
        <h3>NonAktif Data Pasien</h3>
        <hr>

        <div class="row mt-3">
            <h4 class="mb-3">Pencarian Data</h4>
            <div class="col-sm-3">
                <div class="mb-3 row">
                    <label for="tanggal_dari" class="col-sm-4 col-form-label text-end">Dari</label>
                    <div class="col-sm-8">
                        <input type="date" name="tanggal_dari" id="tanggal_dari" class="form-control" v-model="filter.tanggal_dari">
                    </div>
                </div>
            </div>
            <div class="col-sm-3">
                <div class="mb-3 row">
                    <label for="tanggal_sampai" class="col-sm-4 col-form-label text-end">Sampai</label>
                    <div class="col-sm-8">
                        <input type="date" name="tanggal_sampai" id="tanggal_sampai" class="form-control" v-model="filter.tanggal_sampai">
                    </div>
                </div>
            </div>
            <div class="col-sm-4">
                <div class="mb-3 row">
                    <label for="search" class="col-sm-6 col-form-label text-end">No. RM/Nama/NIK/No Kartu BPJS</label>
                    <div class="col-sm-6">
                        <input type="text" name="search" id="search" class="form-control" v-model="filter.search">
                    </div>
                </div>
            </div>
            <div class="col-sm-2">
                <div class="mb-3">
                    <div class="col-sm-8 text-end">
                        <button class="btn btn-danger" @click="resetFilters"><i class="fa fa-refresh"></i> Reset</button>
                        <button class="btn btn-primary" @click="getAllPasien"><i class="fa fa-search"></i> Cari</button>
                    </div>
                </div>
            </div>
        </div>
        <hr>

        <div class="row mt-3">
            <h4 class="mb-3">Data Pasien</h4>
            <div class="col">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>No Rekam Medis</th>
                            <th>Nama</th>
                            <th>Tanggal Lahir</th>
                            <th>NIK</th>
                            <th>No Kartu BPJS</th>
                            <th>Tanggal Daftar</th>
                            <th>Aksi</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="pasien in master_pasiens" :key="pasien.Medrec">
                            <td></td>
                            <td>{{ pasien.Medrec }}</td>
                            <td>{{ pasien.Firstname }}</td>
                            <td>{{ pasien.Bod }}</td>
                            <td>{{ pasien.NoIden }}</td>
                            <td>{{ pasien.AskesNo }}</td>
                            <td>{{ pasien.tgl_daftar }}</td>
                            <td>
                                <button v-if="pasien.Deleted == null" class="btn btn-sm btn-success" @click="nonAktifPasien(pasien.Medrec)">Non Aktif Pasien</button>
                                <button v-if="pasien.Deleted != null" class="btn btn-sm btn-success" @click="aktifPasien(pasien.Medrec)">Aktif Pasien</button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            master_pasiens: [],
            filter: {
                tanggal_dari: '',
                tanggal_sampai: '',
                search: '',
                page: 1,
            }
        }
    },
    created() {
        this.getAllPasien()
    },
    methods: {
        getAllPasien() {
            const uri = `/api/merge-pasien/get-all-pasien?tanggal_dari=${this.filter.tanggal_dari}&tanggal_sampai=${this.filter.tanggal_sampai}&search=${this.filter.search}&page=${this.filter.page}`

            this.axios.get(uri).then(response => {
                const status = response.data.status

                if (status == 'success') {
                    this.master_pasiens = response.data.master_pasiens.data
                }
            })
        },
        nonAktifPasien(medrec) {
            const uri = '/api/status-pasien/nonaktif-pasien'
            const data_pasien = {
                medrec: medrec
            }

            this.axios.post(uri, data_pasien).then(response => {
                const status = response.data.status

                if (status == 'success') {
                    this.getAllPasien()
                }
            })
        },
        aktifPasien(medrec) {
            const uri = '/api/status-pasien/aktif-pasien'
            const data_pasien = {
                medrec: medrec
            }

            this.axios.post(uri, data_pasien).then(response => {
                const status = response.data.status

                if (status == 'success') {
                    this.getAllPasien()
                }
            })
        },
        resetFilters() {
            this.filter = {
                tanggal_dari: '',
                tanggal_sampai: '',
                search: '',
                page: 1,
            }

            this.getAllPasien()
        }
    }
}
</script>